import styles from './SectionBlock.module.scss';
import ReconRow from './ReconRow';
import type { ReconSection } from '../../../../../store/reconciliations/types';

interface SectionBlockProps {
    orgId: string;
    fys: number[] | null;
    section: ReconSection;
}

function SectionBlock({ orgId, fys, section }: Readonly<SectionBlockProps>) {
    return (
        <div className={styles.SectionBlock}>
            <div className={styles.SectionHeader}>{section.label}</div>
            {section.recons.map((recon) => (
                <ReconRow key={recon.id} orgId={orgId} fys={fys} recon={recon} />
            ))}
        </div>
    );
}

export default SectionBlock;
